'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var FullScreen = require('components/common/behaviors/fullscreen');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Requests = require('utils/requests');
var SchemeEditView = require('components/scheme/views/scheme_edit_view');
var SchemeView = require('components/scheme/views/main_view');
var SidebarView = require('components/scheme/views/sidebar_view');
var ST = require('components/scheme/tools');
var SVG = require('utils/svg');
var TabsView = require('components/scheme/views/tabs_view');
var Utils = require('components/common/utils');

var NotFoundView = Marionette.ItemView.extend({
    template: require('components/scheme/templates/notfound'),
});

var newElementWidth = 24;
var newElementHeight = 8;

var SchemeLayoutView = Marionette.LayoutView.extend({
    template: require('components/scheme/templates/layout'),

    controller: undefined,

    regions: {
        schema: '#schema-region',
        tabs: '#tabs-region',
        sidebar: '#sidebar-region',
    },

    ui: {
        container: '#schema-container',
        info: '#info-container',
        controls: '#schema-controls',

        'mouseenter [data-toggle="tooltip"]': Utils.showTooltip,

        // toolbar
        btnRefresh: '#js-refresh',
        btnAutoRefresh: '#js-toggle-auto-refresh',
        btnLegend: '#js-toggle-legend',
        zoomReset: '#js-zoom-reset',
        zoomIn: '#js-zoom-in',
        zoomOut: '#js-zoom-out',
        btnActualValues: '#js-show-actual-values',
        btnSetPointValues: '#js-show-set-point-values',
        btnEdit: '#js-edit-scheme',
        btnBack: '#js-back',
        btnReset: '#js-reset',

        schemaTab: '.js-schema-tab',
        schemaTabs: '#js-schema-tabs',
        scheme: '#schema-svg',
    },

    events: {
        'click @ui.btnAutoRefresh, @ui.zoomReset, @ui.zoomIn, @ui.zoomOut, @ui.btnRefresh, @ui.btnLegend, @ui.btnActualValues, @ui.btnSetPointValues':
            'handleToolbarEvent',
        'click @ui.btnEdit, @ui.btnBack': 'toggleEditMode',
        'click @ui.btnReset': 'resetScheme',
        'click svg': 'editScheme',
        'mousemove svg': 'showPreviewElement',
    },

    childEvents: {
        'fetched:schema': 'showTabsView',
        'scheme:ready': 'afterSchemeRefresh',
        'fetched:customValues': 'updateSidebarView',
        'fetching:customValues': 'showSidebarSpinner',
        'fetched:config': 'onChildViewFetchedConfig',
        'disable:auto:refresh': 'disableAutoRefresh',
        'switched:tab': 'switchSchema',
        'updated:sideBarConfig': 'syncCommonValues',
        'wrote:value': 'refreshValues',
    },

    behaviors: {
        fullscreen: {
            behaviorClass: FullScreen,
            onAfterToggle: function (e) {
                // reset zoom to 1
                this.currentChildView.setZoom(e, true);
            },
            onEnterFullscreen: function () {
                $('.content').addClass('tc-background-content');
                this.ui.scheme.css('background-color', 'white');
            },
            onLeaveFullscreen: function () {
                $('.content').removeClass('tc-background-content');
                this.ui.scheme.css('background-color', 'white');
            },
        },
        lock: {
            behaviorClass: Lock,
            permissions: [Consts.Permissions.StateSchema],

            getDeviceID: function (view) {
                return view.model.id;
            },
        },
    },

    dummySchema: {
        attributes: {
            registers: [],
            coils: [],
        },

        fetch: function (params) {
            params.success();
        },
    },

    refreshValues: function () {
        this.handleToolbarEvent({ currentTarget: { id: 'js-refresh' } });
    },

    handleToolbarEvent: function (e) {
        var buttonID = e.currentTarget.id;
        var params = undefined;
        switch (buttonID) {
            case 'js-toggle-legend':
                this.isLegendShown = !this.isLegendShown;
                this.setControlButtonState(this.ui.btnLegend, this.isLegendShown);
                break;
            case 'js-show-actual-values':
                this.setControlButtonState(this.ui.btnActualValues, true);
                this.setControlButtonState(this.ui.btnSetPointValues, false);
                break;
            case 'js-show-set-point-values':
                this.setControlButtonState(this.ui.btnSetPointValues, true);
                this.setControlButtonState(this.ui.btnActualValues, false);
                break;
            case 'js-toggle-auto-refresh':
                this.isAutoRefresh = !this.isAutoRefresh;
                this.setControlButtonState(this.ui.btnAutoRefresh, this.isAutoRefresh);
                params = this.isAutoRefresh;
                break;
            case 'js-refresh':
                params = true;
                break;
            case 'js-edit-scheme':
                params = undefined;
                break;
        }
        this.currentChildView.handleToolbarEvent(e, params);
    },

    disableAutoRefresh: function () {
        this.isAutoRefresh = false;
        this.setControlButtonState(this.ui.btnAutoRefresh, false);
    },

    setControlButtonState: function (btn, state) {
        if (state) {
            btn.addClass('btn-selected');
        } else {
            btn.removeClass('btn-selected');
        }
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.columns = this.options.columns;
        this.unfetched = false;
        this.is_configurable = options.schema ? options.schema.attributes.is_configurable : true;

        this.inconsistent = [];
        if (options.inconsistent) {
            this.inconsistent = options.inconsistent.data_points || [];
        }
        this.checkConsistency = options.inconsistent !== undefined;

        this.isLegendShown = false;
        this.isAutoRefresh = false;
        this.isShowActualValue = true;
        this.valuesInitialized = false;
        this.hasScheme = true;
        this.viewState = {};
        this.isEditMode = false;
        this.smartTempInfo = options.smartTempInfo;
        this.hcsConfig = options.hcsConfig;

        $(window).on('mouseup', $.proxy(this.updateMinimap, this));

        // init schema tabs
        this.tabs = options.tabs;
        this.activeTab = options.activeTab || 0;
        this.schema = options.schema || this.dummySchema;
        this.tabs[this.activeTab].active = true;
        // init values common to all schemes (these are fetched independently of the active tab)
        this.commonValues = options.sidebarConfig || [];
        var self = this;
        _.each(this.tabs, function (tab) {
            if (tab.highlight) {
                _.each(tab.highlight.conditions, function (cond) {
                    self.commonValues.push(cond.dataPoint);
                });
            }
        });

        this.registers = this.schema.attributes.registers || [];
        this.coils = this.schema.attributes.coils || [];
        this.initSchema();

        // initialize quick analysis
        if (
            options.model.get('category') == '55xx56xx' &&
            options.permissions.attributes[Consts.Permissions.Analysis] !== undefined
        ) {
            var capabilities = options.model.get('capabilities');
            var circuitNames = options.model.getCircuitNames();

            var baseLink =
                Consts.DeviceCategory[options.model.get('category')].url +
                '/' +
                options.model.id +
                '/analyze-predefined?show_events=false';

            // chart period
            var delta = 24 * 60 * 60; // 24 hours
            var now = Math.round(new Date().getTime() / 1000);
            baseLink += '&chart_period={"from":' + (now - delta) + ',"till":' + now + '}';

            var columnInfo = { category: options.model.get('category'), columns: options.columns };
            var analyzeConfig = {
                'pre-control': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_107', 'MBR_13', 'MBR_1000', 'MBR_17', 'MBC_57'],
                    columnInfo
                ),

                'control-water': Misc.getQuickAnalyzeConfig(
                    ['MBR_13', 'MBR_23', 'MBR_24', 'MBR_16', 'MBR_109', 'MBC_61'],
                    columnInfo
                ),

                'control-1': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_107', 'MBR_13', 'MBR_17', 'MBC_57', 'MBR_1000', 'MBR_1033'],
                    columnInfo
                ),
                'control-2': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_109', 'MBR_14', 'MBR_18', 'MBC_58', 'MBR_1200', 'MBR_1233'],
                    columnInfo
                ),
                'control-3': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_111', 'MBR_15', 'MBR_19', 'MBC_59', 'MBR_1400', 'MBR_1433'],
                    columnInfo
                ),
                'control-11': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_11017', 'MBR_11000', 'MBR_11001', 'MBC_4100', 'MBR_11100', 'MBR_11133'],
                    columnInfo
                ),
                'control-12': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_11023', 'MBR_11004', 'MBR_11005', 'MBC_4108', 'MBR_11200', 'MBR_11233'],
                    columnInfo
                ),
                'control-13': Misc.getQuickAnalyzeConfig(
                    ['MBR_10', 'MBR_11', 'MBR_11029', 'MBR_11008', 'MBR_11009', 'MBC_4116', 'MBR_11300', 'MBR_11333'],
                    columnInfo
                ),
            };

            this.quickAnalysisAvailable = false;
            this.quickAnalysisInfo = [];

            var addLink = function (c, n) {
                if (capabilities[c] !== undefined) {
                    self.quickAnalysisAvailable = true;
                    self.quickAnalysisInfo.push({
                        name: circuitNames[n] || Consts.DefaultCircuitNames[n],
                        link: baseLink + (analyzeConfig[n] || ''),
                    });
                }
            };

            // special case: Vorregelkreis
            if (
                capabilities[Consts.Permissions.HandlingCircuit1] === undefined &&
                capabilities[Consts.Permissions.HandlingCircuit2] !== undefined
            ) {
                self.quickAnalysisAvailable = true;
                self.quickAnalysisInfo.push({
                    name: i18n.TR('Vorregelkreis'),
                    link: baseLink + (analyzeConfig['pre-control'] || ''),
                });
            }

            addLink(Consts.Permissions.HandlingCircuit1, 'control-1');
            addLink(Consts.Permissions.HandlingCircuit2, 'control-2');
            addLink(Consts.Permissions.HandlingCircuit3, 'control-3');
            addLink(Consts.Permissions.HandlingWater, 'control-water');
            addLink(Consts.Permissions.HandlingCircuit11, 'control-11');
            addLink(Consts.Permissions.HandlingCircuit12, 'control-12');
            addLink(Consts.Permissions.HandlingCircuit13, 'control-13');
        }
    },

    // first argument is the event, which is not needed here.
    showTabsView: function (_unused, data) {
        var view = new TabsView({
            tabs: this.tabs,
            data: data,
            activeTab: this.activeTab,
        });
        if (this.tabs.length > 1) {
            this.showChildView('tabs', view);
        }
    },

    showSidebarSpinner: function () {
        if (this.hasScheme && this.sidebarIsVisible()) {
            this.getChildView('sidebar').showOrHideSpinner(!this.isAutoRefresh);
        }
    },

    syncCommonValues: function (unused, config) {
        if (this.sidebarIsVisible()) {
            this.options.sidebarConfig = config;
            // sync common values between all views
            this.commonValues = _.unique(_.union(this.commonValues, config));
            this.getChildView('schema').commonValues = this.commonValues;
        }
    },

    updateSidebarView: function (unused, values) {
        if (this.sidebarIsVisible() && !this.isEditMode) {
            this.getChildView('sidebar').update(values);
        }
    },

    showSidebar: function () {
        if (!this.sidebarIsVisible()) {
            return;
        }

        var sidebarView = new SidebarView({
            canWriteValues: this.canWriteValues,
            canConfigureValues: this.canConfigureValues,
            device: $.extend(true, {}, this.model),
            sensorValues: this.options.sensorValues,
            columns: $.extend(true, {}, this.options.columns),
            controller: this.controller,
            valueList: this.options.valueList,
            sidebarConfig: this.options.sidebarConfig,
            values: this.options.values,
            hasTabs: this.tabs.length > 1,
            smartTempInfo: this.smartTempInfo,
            hcsConfig: this.hcsConfig,
        });

        this.showChildView('sidebar', sidebarView);
    },

    onDomRefresh: function () {
        this.initSchema();
        $('button').tooltip({
            html: true,
            container: 'body',
            trigger: 'hover',
        });

        // test browsersupport for scrolling (edge...)
        try {
            this.ui.container[0].scrollBy(0, 0);
        } catch (err) {
            // browser does not support scrolling by javascript? -> no minimap
            this.viewState.noScroll = true;
        }

        this.showTabsView(undefined, $.extend({}, this.schema.attributes.coils, this.schema.attributes.registers));
        this.showSidebar();
    },

    afterSchemeRefresh: function () {
        if (this.isEditMode) {
            // show all hidden predefined elements
            _.each($(".SDECustom[style='display:none']"), function (element) {
                element.setAttribute('style', '');
                $(element).find('tspan').attr('class', 'js-hidden-element');
                var rect = $(element).children('rect');
                rect.attr('class', 'hidden-element-visualization');
                $(element).children('text').children('tspan').text('');
            });
            // create an overlay to cover the whole scheme except the custom elements
            var blurOverlay = SVG.createSVGElement(
                'rect',
                $.extend(
                    {
                        id: 'js-preview',
                        stroke: '#ffa',
                        'stroke-width': 0.2,
                        fill: 'gray',
                        'fill-opacity': 0.4,
                        rx: 2,
                    },
                    this.viewBox
                )
            );

            var svg = $('#schema-container>svg')[0];
            var customElements = document.getElementsByClassName('SDECustom');
            if (customElements === undefined) {
                svg.appendChild(blurOverlay);
                return;
            }

            // append before first custom element
            var firstElement = customElements[0];
            svg.insertBefore(blurOverlay, firstElement);
        }
    },

    setPermission: function (permissions) {
        this.readOnly = permissions.get(Consts.Permissions.StateSchema) || this.model.isWritingDisabled();
        this.canConfigureValues = false === permissions.get(Consts.Permissions.AdminConfig);
        var hasWritePermissions =
            permissions.get(Consts.Permissions.StateSchema) === false ||
            permissions.get(Consts.Permissions.StateData) === false;
        this.canWriteValues = !this.model.isWritingDisabled() && hasWritePermissions;
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.readOnly = this.readOnly;
        data.showLegend = this.model.get('type');

        data.quickAnalysisAvailable = this.quickAnalysisAvailable;
        data.quickAnalysisInfo = this.quickAnalysisInfo;

        data.hints = [
            {
                id: 'js-inconsistency-hint',
                icon: 'fa fa-hourglass',
                message: i18n.TR('Schreibbefehl wird verarbeitet'),
            },
            {
                id: 'js-lock-hint',
                icon: 'fa fa-lock',
                message: i18n.TR('Gerät ist gesperrt'),
            },
            {
                id: 'js-unfetched-hint',
                icon: 'fa fa-warning warning',
                message: i18n.TR('Einige Werte konnten nicht geladen werden'),
            },
            {
                id: 'js-loading-values-hint',
                icon: 'fa fa-spinner fa-spin',
                message: i18n.TR('Werte werden geladen'),
            },
        ];
        data.tabs = _.keys(this.tabs).length > 1 ? this.tabs : undefined;
        data.showSensors = this.sidebarIsVisible();
        var showNoConfigHint = !this.readOnly && !this.is_configurable;
        data.warnings = [];
        if (showNoConfigHint) {
            data.warnings.push({
                title: i18n.TR('Keine Einstellungen möglich.'),
                info: i18n.TR(
                    'Das Gerät befindet sich vor Ort nicht im Automatik-Betrieb. Eine Bedienung ist somit nicht möglich.'
                ),
            });
        }
        if (this.smartTempInfo) {
            data.warnings = data.warnings.concat(this.smartTempInfo.getWarnings());
        }
        data.canEditScheme = AppState.hasCompanyDevicePermission();
        data.isEditMode = this.isEditMode;
        data.canResetScheme = data.category == Consts.CategoryData.Controller.category;
        return data;
    },

    switchSchema: function (_e, activeTab) {
        this.activeTab = activeTab;
        this.hasPreview = false;
        // reflect the tab-change in the URL and add it to the history
        history.pushState({}, document.title, window.location.href.split('?')[0] + '?tab=' + activeTab);
        this.initSchema();
    },

    onChildViewFetchedValues: function (childView, valueMap) {
        this.tabs[this.activeTab].valueMap = valueMap;
    },

    onChildViewFetchedConfig: function (childView, valueConfig) {
        this.tabs[this.activeTab].valueConfig = valueConfig;
    },

    initSchema: function () {
        var self = this;
        Requests.firstURLfromList(
            this.tabs[this.activeTab].urls,
            function (data, url) {
                self.hasScheme = true;
                self.tabs[self.activeTab].svg = data;
                self.url = url;
                self.showSchema(true);
            },
            function () {
                // no schema available
                self.hasScheme = false;
                self.showChildView('schema', new NotFoundView({}));
            },
            'xml'
        );
    },

    onBeforeDestroy: function () {
        // remove resize handler
        var handlerFuncIndex = window.resizefunc.indexOf('svgSchemaResizeHandler');
        if (handlerFuncIndex != -1) {
            window.resizefunc.splice(handlerFuncIndex, 1);
            window.svgSchemaResizeHandler = undefined;
        }
        $(window).off('mouseup', $.proxy(this.updateMinimap, this));
    },

    showSchema: function () {
        var options = this.options;
        options.schema = this.schema;

        if (Utils.isInternetExplorer()) {
            // The InternetExplorer does not support cloneNode
            // -> pass original svg to the childView
            // -> svg will be destroyed on switch tab
            // -> re-fetch the schema each time in switchSchema
            var svg = $(this.tabs[this.activeTab].svg).find('svg');
        } else {
            // make a deep copy of the svg.
            var svg = $(this.tabs[this.activeTab].svg.cloneNode(true)).find('svg');
        }

        svg.attr('id', 'schema-svg');
        svg.attr('xml:space', 'default');

        options.svg = svg;
        options.valueMap = this.tabs[this.activeTab].valueMap;
        options.valueConfig = this.tabs[this.activeTab].valueConfig;
        options.circuitNr = this.tabs[this.activeTab].circuitID;
        options.isAutoRefresh = this.isAutoRefresh;
        options.commonValues = this.commonValues;
        options.readOnly = this.readOnly || this.is_configurable === false || this.isEditMode;
        options.isEditMode = this.isEditMode;
        this.currentChildView = new SchemeView(options);
        // reset non-global toolbar button states
        this.ui.btnLegend.removeClass('btn-selected');
        this.ui.btnActualValues.addClass('btn-selected');
        this.ui.btnSetPointValues.removeClass('btn-selected');
        this.showChildView('schema', this.currentChildView);

        // show toolbar
        this.ui.controls.removeClass('hidden');
    },

    // sidebar is visible, if
    // + the user can see the scheme
    // + and at least one of the following is true:
    //    - user has write permissions on the scheme-tab
    //    - user has write permissions on the configuration-tab
    //    - there are custom values configured
    //    - user has permission to see at least one scheme-relevant meter
    sidebarIsVisible: function () {
        if (this.isEditMode) {
            return false;
        }
        var self = this;
        var canAccessAnySensorValues = false;
        // is there any sensor with any data, that is accessible by the current user?
        _.each(this.options.sensorValues, function (valueList) {
            canAccessAnySensorValues =
                canAccessAnySensorValues ||
                _.any(valueList.data, function (value, key) {
                    return _.findWhere(self.options.columns, { id: key });
                });
        });
        return (
            this.hasScheme &&
            (this.canConfigureValues || this.options.sidebarConfig.length > 0 || canAccessAnySensorValues)
        );
    },

    toggleEditMode: function () {
        this.isEditMode = !this.isEditMode;
        if (this.isEditMode) {
            this.hasPreview = false;
            this.viewBox = $('#schema-container>svg')[0].viewBox.baseVal;
        }
        this.render();
        this.customElementCount = 0;
        $('.tooltip').tooltip('hide');
    },

    getCustomElement: function (e) {
        function elementIsCustomizable(e) {
            var appFunc = e.attributes['app-func'];
            if (appFunc && (appFunc.value.includes('$') || appFunc.value == '')) {
                return true;
            }
            return false;
        }
        if (elementIsCustomizable(e)) {
            return e;
        }
        // clicked on a rectangle? user might wanted to click the textbox
        if (
            e.tagName === 'rect' &&
            e.nextElementSibling &&
            e.nextElementSibling.tagName === 'text' &&
            e.nextElementSibling.children &&
            e.nextElementSibling.children.length > 0 &&
            e.nextElementSibling.children[0].tagName === 'tspan' &&
            elementIsCustomizable(e.nextElementSibling.children[0])
        ) {
            return e.nextElementSibling.children[0];
        }
        if (e.id === 'schema-svg' || e.parentElement === null) {
            return undefined;
        }
        return this.getCustomElement(e.parentElement);
    },

    editScheme: function (e) {
        if (!this.isEditMode) {
            return;
        }

        var scheme = e.currentTarget;
        var coor = SVG.getSVGCoordinatesFromScreen(scheme, e.clientX, e.clientY);
        coor = this.restrictToViewBox(coor);

        var customizedElement = this.getCustomElement(e.target);
        var elementType = customizedElement
            ? (customizedElement.attributes['app-type'] || {}).value || 'value'
            : 'value';

        var values = [];
        var sv = this.getChildView('schema');
        var ID = '';
        var isNewElement = true;
        var isVisible = customizedElement ? customizedElement.className.baseVal !== 'js-hidden-element' : true;

        if (customizedElement != undefined) {
            isNewElement = false;

            if (elementType === 'text') {
                ID = customizedElement.attributes['app-id'].value;
                values = [customizedElement.innerHTML];
            } else {
                var parameters = customizedElement.attributes['app-func'].textContent.split('(')[1];
                ID = parameters.substring(parameters.search(/\$[c,s]{1}[0-9]+/)).replace(')', '');

                // we have a hidden standard element with no values -> create two default entries as params
                if (!isVisible) {
                    values = [
                        { address: undefined, deviceID: this.model.id },
                        { address: undefined, deviceID: this.model.id },
                    ];
                } else {
                    _.each(parameters.substring(0, parameters.length - 1).split(','), function (param) {
                        var p = sv.parseDeviceDataPoint(param);
                        values.push(
                            _.map(p.registerList, function (dataPoint) {
                                return { address: dataPoint, deviceID: p.deviceID };
                            })
                        );
                        values = _.flatten(values);
                    });
                }
            }
        }

        App.showModal(
            new SchemeEditView({
                isNewElement: isNewElement,
                isVisible: isVisible,
                isCustomElement: ID === '' || ID.startsWith('$c'),
                callbackParams: {
                    ID: ID,
                    coordinates: coor,
                    element: isNewElement ? undefined : e.target,
                },
                deviceID: this.model.id,
                save: this.save.bind(this),
                type: elementType,
                params: values,
            })
        );
    },

    resetScheme: function (e) {
        if (!this.isEditMode) {
            return;
        }

        var self = this;
        Utils.showConfirmationDialog({
            title: i18n.TR('Schema zurücksetzen'),
            hint: i18n.TR(
                'Die Darstellung des Anlagenschemas wird auf das Standard-Bild zurückgesetzt. Anpassungen werden gelöscht.'
            ),
            action_label: i18n.TR('Löschen'),
            cancel_label: i18n.TR('Abbrechen'),

            action_cb: function () {
                App.ajax({
                    url: '/api/v1/devices/' + self.model.id + '/scheme-edit',
                    method: 'DELETE',
                    success: function () {
                        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Schema wurde gespeichert.'));
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    },
                    error: function () {
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Schema konnte nicht gespeichert werden.')
                        );
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    },
                });

                self.destroy();
            },
        });
    },

    restrictToViewBox: function (coor) {
        // calculated the bundearies for the text box position, so that it still fits inside the viewBox
        var maxX = this.viewBox.x + this.viewBox.width - newElementWidth / 2;
        var maxY = this.viewBox.y + this.viewBox.height - newElementHeight / 2;
        var minX = this.viewBox.x + newElementWidth / 2;
        var minY = this.viewBox.y + newElementHeight / 2;

        return {
            x: Misc.clamp(coor.x, minX, maxX) - newElementWidth / 2,
            y: Misc.clamp(coor.y, minY, maxY) - newElementHeight / 2,
            outsideOfViewBox: coor.x != Misc.clamp(coor.x, minX, maxX) || coor.y != Misc.clamp(coor.y, minY, maxY),
        };
    },

    initializePreview: function (x, y) {
        ++this.customElementCount;
        var group = SVG.createSVGElement('g', {
            id: 'SDECustom-' + this.customElementCount,
            class: 'SDECustom',
            'pointer-events': 'none',
        });
        document.getElementById('schema-svg').appendChild(group);

        SVG.drawRectangle(group, {
            class: 'feeler-value value-box preview',
            x: x,
            y: y,
            width: newElementWidth,
            height: newElementHeight,
        });
    },

    showPreviewElement: function (e) {
        // abort when not in edit mode or when hovering over a custom element
        if (!this.isEditMode) {
            return;
        }

        var coor = SVG.getSVGCoordinatesFromScreen($('#schema-container').children('svg')[0], e.clientX, e.clientY);
        coor = this.restrictToViewBox(coor);

        if (!this.hasPreview) {
            this.initializePreview(coor.x, coor.y);
            this.hasPreview = true;
            return;
        }
        // hide preview, if the user hovers over an editable element
        var preview = document.getElementById('SDECustom-' + this.customElementCount);
        if (this.getCustomElement(e.target) != undefined || coor.outsideOfViewBox) {
            preview.style.display = 'none';
        } else {
            preview.style.display = '';
        }

        var rect = $(preview).children('rect')[0];
        rect.setAttribute('x', coor.x);
        rect.setAttribute('y', coor.y);
    },

    save: function (payload, params) {
        var self = this;
        Decorator.disableElement('.modal-dialog');
        App.ajax({
            url: '/api/v1/devices/' + this.model.id + '/scheme-edit',
            method: 'POST',
            data: JSON.stringify({
                width: newElementWidth,
                height: newElementHeight,
                x: params.coordinates.x,
                y: params.coordinates.y,
                fileName: this.url.split('/scheme/')[1],
                values: payload,
                mode: params.mode,
                type: params.type,
                id: params.ID,
                tab_id: this.activeTab,
                is_visible: params.isVisible,
            }),
            dataType: 'text',
            success: function () {
                // get updated scheme tabs
                var tabReq = App.request('schema:additional', self.model.id);
                $.when(tabReq).done(function (tabResp) {
                    self.tabs = self.controller.initTabs(
                        self.model,
                        self.options.permissions,
                        self.model.attributes.trovis_io_infos,
                        !$.isEmptyObject(tabResp) ? tabResp : undefined
                    );
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Schema wurde gespeichert.'));

                    self.hasPreview = false;
                    self.render();
                });
            },
            error: function () {
                App.hideModal();
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Schema konnte nicht gespeichert werden.'));
            },
        });

        if (params.mode == ST.Modes.DELETE) {
            var element = params.element;
            while (element != undefined && element.className.baseVal != 'SDECustom') {
                element = element.parentElement;
            }
            if (element != undefined) {
                element.remove();
            }
        }
    },
});

module.exports = SchemeLayoutView;
